import React from "react"
import { Col } from "react-bootstrap"
import ContentLoader from "react-content-loader"

const SkillHeaderLoader = () => (
  <Col lg={{ offset: 2 }} md={{ offset: 2 }} sm={{ offset: 2 }} style={{ height: "200px" }}>
    <ContentLoader
      speed={2}
      width={"100%"}
      height={"100%"}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <circle cx="98" cy="94" r="82" />
      <rect x="225" y="30" rx="3" ry="3" width="380" height="18" />
      <rect x="225" y="60" rx="3" ry="3" width="360" height="18" />
      <rect x="225" y="90" rx="3" ry="3" width="340" height="18" />
      <rect x="225" y="120" rx="3" ry="3" width="320" height="18" />
    </ContentLoader>
  </Col>
)

export default SkillHeaderLoader

